import { updateAccountUI } from './account.js';
import { CLOUD, cloudPersistLS, loadUser, sbFetch, sbUrl, setAuth } from './api.js';
import { maybeShowAuth } from './authui.js';
import { setStatus, stopPolling, syncPersistLS } from './sync.js';
import { PUSH } from '../notify/push.js';
import { t } from '../i18n/index.js';
import { $, RT, esc, render, toast } from '../ui.js';
import { S, defaultState, rawSave, setState } from '../state.js';
import { TEAM } from '../team/team.js';

export const WEAKPW=['password','passwort','123456','12345678','qwerty','qwertz','azerty','letmein','welcome','admin','iloveyou','motdepasse','plume'];
export function pwScore(pw){
  if(!pw)return{n:0};
  const low=pw.toLowerCase();
  if(WEAKPW.some(w=>low.includes(w)))return{n:1};
  if(/^(.)\1+$/.test(pw))return{n:1};
  if(pw.length<10)return{n:pw.length>=8?1:0};
  let cls=0;
  if(/[a-z]/.test(pw))cls++;
  if(/[A-Z]/.test(pw))cls++;
  if(/[0-9]/.test(pw))cls++;
  if(/[^A-Za-z0-9]/.test(pw))cls++;
  let n=1;
  if(pw.length>=10&&cls>=2)n=2;
  if(pw.length>=12&&cls>=3)n=3;
  if(pw.length>=14&&cls>=3)n=4;
  return{n};
}
export function pwOK(pw){return pwScore(pw).n>=2}
export function drawPwMeter(pw){
  const el=$('#au-meter');if(!el)return;
  const s=pwScore(pw);
  const labels=[t('auth.pw0'),t('auth.pw1'),t('auth.pw2'),t('auth.pw3'),t('auth.pw4')];
  const cols=['var(--marge)','var(--marge)','var(--warn)','var(--ok)','var(--ok)'];
  el.innerHTML='<div class="pwbars">'+[0,1,2,3].map(i=>'<i style="background:'+(i<s.n?cols[s.n]:'var(--hair)')+'"></i>').join('')+'</div>'+
    '<span class="tiny" style="color:'+(s.n>=2?'var(--ink3)':'var(--marge)')+'">'+esc(pw?labels[s.n]:t('auth.pwHint'))+'</span>';
}

/* ---------------- auth actions ---------------- */
export async function cloudSignIn(email,pw){
  const d=await sbFetch('/auth/v1/token?grant_type=password',{method:'POST',body:JSON.stringify({email,password:pw})},true);
  setAuth(d);
  return await mfaRequired();
}
export async function cloudSignUp(email,pw,name){
  const d=await sbFetch('/auth/v1/signup',{method:'POST',body:JSON.stringify({email,password:pw,data:name?{full_name:name}:{}})},true);
  if(d&&d.access_token){setAuth(d);return 'in'}
  /* an existing account comes back as a user without identities and no email is sent */
  const u=d&&(d.user||d);
  if(u&&Array.isArray(u.identities)&&u.identities.length===0)throw new Error('already registered');
  return 'otp';
}
export async function verifyOtp(email,token,type){
  const d=await sbFetch('/auth/v1/verify',{method:'POST',body:JSON.stringify({email,token,type:type||'signup'})},true);
  if(!setAuth(d))throw new Error(t('auth.eCode'));
  return true;
}
/* Passwordless: one entry for new and existing users (code or link by email). */
export async function sendEmailCode(email,create){
  const back=encodeURIComponent(location.origin+'/');
  await sbFetch('/auth/v1/otp?redirect_to='+back,{method:'POST',body:JSON.stringify({email,create_user:!!create})},true);
}
export async function verifyEmailCode(email,code){
  let last;
  for(const type of ['email','signup','magiclink']){
    try{const d=await sbFetch('/auth/v1/verify',{method:'POST',body:JSON.stringify({email,token:code,type})},true);if(setAuth(d))return true}
    catch(e){last=e}
  }
  throw last||new Error(t('auth.eCode'));
}
export async function resendOtp(email,type){await sbFetch('/auth/v1/resend',{method:'POST',body:JSON.stringify({email,type:type||'signup'})},true)}
export async function sendRecovery(email){await sbFetch('/auth/v1/recover',{method:'POST',body:JSON.stringify({email})},true)}
export async function updatePassword(pw){const d=await sbFetch('/auth/v1/user',{method:'PUT',body:JSON.stringify({password:pw})});return d}

/* ---------------- MFA (TOTP) ---------------- */
export function verifiedFactors(u){return ((((u||CLOUD.user)||{}).factors)||[]).filter(f=>f.status==='verified'&&f.factor_type==='totp')}
export function tokenAAL(){try{return JSON.parse(atob(CLOUD.auth.at.split('.')[1].replace(/-/g,'+').replace(/_/g,'/'))).aal||'aal1'}catch(e){return 'aal1'}}
export async function mfaRequired(){
  try{
    const u=await loadUser();
    const f=verifiedFactors(u);
    if(f.length&&tokenAAL()!=='aal2'){CLOUD.mfa=f[0];return true}
  }catch(e){}
  CLOUD.mfa=null;return false;
}
export async function mfaChallenge(factorId){return await sbFetch('/auth/v1/factors/'+factorId+'/challenge',{method:'POST',body:'{}'})}
export async function mfaVerify(factorId,challengeId,code){
  const d=await sbFetch('/auth/v1/factors/'+factorId+'/verify',{method:'POST',body:JSON.stringify({challenge_id:challengeId,code})});
  setAuth(d);return true;
}
export async function mfaEnroll(){return await sbFetch('/auth/v1/factors',{method:'POST',body:JSON.stringify({factor_type:'totp',friendly_name:'Plume '+Date.now()})})}
export async function mfaUnenroll(id){await sbFetch('/auth/v1/factors/'+id,{method:'DELETE'})}

export function cloudSignOut(quiet){
  if(PUSH.sub&&CLOUD.auth&&CLOUD.auth.at&&Date.now()<CLOUD.auth.exp){
    fetch(sbUrl('/rest/v1/rpc/delete_push_subscription'),{method:'POST',keepalive:true,
      headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at,'Content-Type':'application/json'},
      body:JSON.stringify({p_endpoint:PUSH.sub.endpoint})}).catch(()=>{});
  }
  clearTimeout(CLOUD.t);stopPolling();CLOUD.auth=null;CLOUD.user=null;CLOUD.mfa=null;CLOUD.rev=null;CLOUD.dirty=false;CLOUD.ctx=null;CLOUD.org=null;syncPersistLS();
  try{['plume.v1','plume.rev','plume.dirty','plume.owner','plume.ctx','plume.team'].forEach(k=>localStorage.removeItem(k))}catch(e){}
  try{const keep={lang:S.settings.lang,theme:S.settings.theme};const d=defaultState();d.settings.lang=keep.lang;d.settings.theme=keep.theme;setState(d);rawSave(d)}catch(e){}
  TEAM.orgs=null;TEAM.members=null;TEAM.invites=null;
  try{render()}catch(e){}
  cloudPersistLS();setStatus('off');updateAccountUI();
  if(!quiet){if(RT.v==='settings')render();maybeShowAuth({notice:t('lg.signedOut')})}
}

/* ================= auth UI ================= */
